import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ellipsis"
}
const _hoisted_2 = {
  key: 1,
  class: "ellipsis"
}

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import EmptyState from "./EmptyState.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Dropdown',
  props: {
    value: {},
    menuClass: {},
    items: {},
    textField: {},
    valueField: {},
    displayField: {},
    boundary: {},
    block: { type: Boolean },
    disabled: { type: Boolean },
    active: { type: Boolean },
    default: {},
    showTooltip: { type: Boolean },
    popperOpts: {},
    isDropUp: { type: Boolean },
    emptyState: {}
  },
  emits: ["input", "change"],
  setup(__props: any, { emit }) {

const props = __props;

const { t: $t } = useI18n();




const localItems = computed(() => {
  return props.items || [];
});

const itemMap = computed(() => {
  const map: Map<any, any> = new Map();
  for (const item of localItems.value) {
    map.set(item[props.valueField], item);
  }
  return map;
});

const selectedItem = computed(() => (props.value !== undefined && itemMap.value.has(props.value) ? itemMap.value.get(props.value) : null));

const selectedDisplayText = computed(() => {
  return selectedItem.value?.[props.displayField || props.textField];
});

const calcMenuClass = computed(() => {
  return [props.boundary, props.menuClass].filter((x) => x);
});

const emptyStateText = computed(() => {
  return props.emptyState ? props.emptyState : $t("dropdown.emptyState.default");
});

function selectItem(item: T) {
  emit("input", item[props.valueField]);
  emit("change", item[props.valueField]);
}

return (_ctx: any,_cache: any) => {
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_b_dropdown, {
    boundary: _ctx.boundary,
    class: "dropdown-default",
    dropup: _ctx.isDropUp,
    "menu-class": calcMenuClass.value,
    disabled: _ctx.disabled,
    block: _ctx.block,
    "popper-opts": _ctx.popperOpts
  }, {
    "button-content": _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {
        selectedItem: selectedItem.value,
        selectedText: selectedDisplayText.value
      }, () => [
        (_ctx.showTooltip)
          ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_1, [
              _createTextVNode(_toDisplayString(selectedDisplayText.value || props.default), 1)
            ])), [
              [
                _directive_tooltip,
                selectedDisplayText.value || props.default,
                void 0,
                { ellipsis: true }
              ]
            ])
          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(selectedDisplayText.value || props.default), 1))
      ])
    ]),
    default: _withCtx(() => [
      (!_ctx.items.length)
        ? (_openBlock(), _createBlock(EmptyState, {
            key: 0,
            "is-insde-element": ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(emptyStateText.value), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localItems.value, (item) => {
        return (_openBlock(), _createBlock(_component_b_dropdown_item, {
          key: item[props.valueField],
          "data-cy": item[_ctx.valueField],
          onClick: ($event: any) => (selectItem(item)),
          active: _ctx.active === true ? true : item[props.valueField] === selectedItem.value?.[_ctx.valueField]
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "item-template", { entry: item }, () => [
              _createTextVNode(_toDisplayString(item ? item[props.textField] : ""), 1)
            ])
          ]),
          _: 2
        }, 1032, ["data-cy", "onClick", "active"]))
      }), 128))
    ]),
    _: 3
  }, 8, ["boundary", "dropup", "menu-class", "disabled", "block", "popper-opts"]))
}
}

})